import {Injectable} from '@angular/core'
import {colorProfiles, GlobalConstants, PROCESSING_STATUS_MAPPING, STATUS_MAPPING} from 'src/constants/global-constants'
import {Grouping} from "../models/api.model";

@Injectable({
  providedIn: 'root'
})
export class TableService {

  buildProcessingStatusChip(status: string) {
    const statusObj = PROCESSING_STATUS_MAPPING[status]
    const colorProfile = colorProfiles[statusObj.profile]

    return `<div class="status-chip" style="background:${colorProfile.bg_color}; color: ${colorProfile.text_color};">
                ${statusObj.label}
            </div>`
  }

  buildStatusChip(status: string) {
    const statusObj = STATUS_MAPPING[status]
    const colorProfile = colorProfiles[statusObj.profile]

    return `<div class="status-chip" style="background:${colorProfile.bg_color}; color: ${colorProfile.text_color};">
                <a class="html-anchor-cell" data-action="showPaymentHistoryAction">${statusObj.label}</a>
            </div>`
  }

  buildStatusChipForExpReport(status: string, count: number) {
    const statusObj = STATUS_MAPPING[status]
    const colorProfile = colorProfiles[statusObj.profile]

    return `<div class="status-chip" style="background:${colorProfile.bg_color}; color: ${colorProfile.text_color};">
                <a class="html-anchor-cell" data-action="view-expenses" data-context="${status}">${statusObj.label + ' - ' + count}</a>
            </div>`
  }

  buildAmountColumnHTML(currencyCode: string, amount: number) {
    return `<div>${this.buildAmountColumnString(currencyCode, amount)}</div>`
  }

  buildAmountColumnString(currencyCode: string, amount: number) {
    const currency = GlobalConstants.CURRENCY_SYMBOL_MAPPING[currencyCode] || ''
    const formattedAmount = amount?.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })

    return `${currency}&nbsp;&nbsp;${formattedAmount}`
  }

  buildGroupingDisplay(grouping: Grouping[], action: string): string {
    if (!grouping.length) {
      return ""
    }
    let html = `
        <div class="grouping-container">
          <div class="header">
              <div class="currency">Key</div>
              <div class="code">Count</div>
              <div class="amount">Sub total</div>
          </div>`;

    grouping.forEach(grouping => {
      html += `
        <div class="entry">
            <div class="currency">${grouping.key}</div>
            <div class="code"><a class="html-anchor-cell" data-action="${action}" data-context="${grouping.key}">${grouping.count}</a></div>
            <div class="amount">${this.buildAmountColumnString(grouping.currency, grouping.amount)}</div>
        </div>
    `;
    });
    html += '</div>';
    return html
  }
}
